<template>
  <v-list-item class="version-item" data-cy="podMenu-tools-manageVersions-item">
    <v-list-item-title style="line-height: 1.2;" data-cy="podMenu-tools-manageVersions-itemTitle">
      <b>
        <router-link :to="'/pod/' + pod.id">{{ pod.name }}</router-link>
      </b>
    </v-list-item-title>

    <v-list-item-subtitle data-cy="podMenu-tools-manageVersions-itemText">
      {{ pod.versiontext }}
    </v-list-item-subtitle>

    <template v-slot:append>
      <v-list-item-action>
        <v-btn
          v-if="$canControlPodService() && pod.id !== viewPod.id"
          v-on:click="$emit('removeItem', pod.id)"
          density="comfortable"
          variant="text"
          rounded="36"
          height="36"
          width="36"
          icon
          tile
          data-cy="podMenu-tools-manageVersions-removeItem-btn"
          :aria-label="$t('common.delete')"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';

export default {
  name: "PodVersionItem",
  props: {
    pod: {
      type: Object,
      required: true,
    }
  },
  computed: {
    viewPod: function() {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
  }
}
</script>
